window.M = window.M || {};

$.get("/api/User/Current", function(me) {
    M.CurrentUser = me;
    if(!M.CurrentUser.Roles) M.CurrentUser.Roles = [];
    M.MiniProfiler.render(function() {
        $(document).trigger("userLoaded");
    });
    M.CurrentUser.HasRole = function(role) {
        if(M.CurrentUser.IsAdmin) return true;
        return M.CurrentUser.Roles.indexOf(role) !== -1;
    };
});

//$("#main").html(M.templates.loading());